import { Button, Col, Form, Modal, Row, Spin, message } from 'antd';
import { get } from 'lodash';
import React, { useMemo, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useAppContext } from '../../../common/components/appContext';
import Dashboard from '../../../common/components/dashboard';
import OrganisationsLookup from '../../../common/components/lookupSelect/OrganisationsLookup';
import useHttpHelper from '../../../common/hooks/useHttpHelper';
import { appLinks, queryKeys } from '../../../config/constants';
import CreateForm from '../create';
import EditForm from '../edit';
import Table from './table';
import useAgeFilterContext from './useFilterContext';
//import Search from '../../../common/components/search';
//import useDifficultyPermissionsContext from '../../../common/components/permissionContext/useDifficultyPermissions';

const pageSize = 10;

export default () => {

    const { httpPostAsync, httpPutAsync, httpDeleteAsync } = useHttpHelper();

    const { user } = useAppContext();

    const { searchParams, setSearchParams, isSearchActive, resetSearchParams } = useAgeFilterContext();

    const {
        pageNo = 0,
        query = '',
        organisationId = user.defaultOrganisationId,
        sortBy = null,
        sortOrder = null,
    } = searchParams

    //#region organsation dropdown and default value

    const onOrganisationChange = (e) => {
        try {

            console.log('organisations id', e);
            setSearchParams({ organisationId: e });

        } catch (error) {
            console.log('error on organisation change', error);
        }
    }
    //#endregion


    const fetchAgesAsync = async () => {

        const filterParams = {
            itemPerPage: pageSize,
            organisationId: organisationId,
            query,
            pageNo,
            sortBy,
            sortOrder
        }

        console.log('fetch ages filter', filterParams)

        const response = await httpPostAsync(appLinks.agesList, { ...filterParams });

        console.log('fetch ages for admin', response);

        return response;
    };

    const queryKey = useMemo(() => {

        const key = [queryKeys.settingsAgesList, organisationId, query, sortBy, sortOrder, pageNo];

        return key;

    }, [user, organisationId, query, sortBy, sortOrder, pageNo])

    const {
        isLoading,
        //isError,
        //error,
        data = [],
        isFetching,
        // isPreviousData,
        refetch,
    } = useQuery(
        queryKey,
        fetchAgesAsync,
        {
            keepPreviousData: true,
            refetchOnWindowFocus: false
        });

    let { data: difficulty = [], total = 0, } = data || {}

    //#region Edit TODO move to hook
    const editForm = Form.useForm();
    const [isEditVisible, setIsEditVisible] = useState(false);
    const [editDifficultyLevel, setEditDifficultyLevel] = useState({});

    const showEditModal = (age) => {
        console.log('show edit modal age ', age)
        setIsEditVisible(true);
        setEditDifficultyLevel(age)
    }

    const closeEditModal = () => setIsEditVisible(false);

    const onEditClick = () => {
        try {

            editForm[0].submit();

        } catch (error) {
            console.log('error on edit age modal', error);
        }
    }

    const udpateAgeAsync = async (data) => {

        console.log('updated data', data);

        const link = appLinks.updateAge.replace('{ageId}', editDifficultyLevel.id);
        // console.log('accept challenge link', link);
        console.log('udpate post data', data);
        const difficultyData = { ...data, organisationId };
        const response = await httpPutAsync(link, difficultyData);
        console.log('update age async', response);

        return response;
    };

    const editDifficultyId = editDifficultyLevel?.id;

    const mutationQueryKey = useMemo(() => {
        return [queryKeys.updateAge, organisationId, editDifficultyId]
    }, [organisationId, editDifficultyId])

    const {
        // data: updatePersonResponse,
        isLoading: isUpdating,
        mutateAsync: onUpdateAgeAsync,
    } = useMutation(
        udpateAgeAsync,
        { mutationKey: mutationQueryKey, }
    );

    const onUpdateAsync = async (values) => {
        try {

            console.log('on update callback', values);

            const response = await onUpdateAgeAsync(values);

            if (response.code === 0) {
                refetch();
                closeEditModal();
                message.success('Age was updated successfully');

            } if (response && response.code !== 0) {
                message.error('Age could not be updated');
                closeEditModal();
            }

            // console.log('updated resonse', response);

        } catch (error) {
            console.log('error on update async', error);
        }
    }

    //#endregion

    //#region create theme
    const createForm = Form.useForm();
    const [isCreateVisible, setIsCreateVisible] = useState(false);

    const showCreateModal = () => {
        setIsCreateVisible(true);
    }

    const closeCreateModal = () => setIsCreateVisible(false);

    const onCreateClick = () => {
        try {

            createForm[0].submit();

        } catch (error) {
            console.log('error on create theme modal submit', error);
        }
    }

    const createAgeAsync = async (data) => {

        console.log('create data', data);

        const link = appLinks.createAge
        // console.log('accept challenge link', link);
        //console.log('create post data', data);
        const postData = { ...data, organisationId };
        const response = await httpPostAsync(link, postData);
        console.log('create age async', response);

        return response;
    };

    const mutationCreateQueryKey = useMemo(() => {
        return [queryKeys.createAge, organisationId]
    }, [organisationId])

    const {
        // data: updatePersonResponse,
        isLoading: isCreating,
        mutateAsync: createNewAgeAsync,
    } = useMutation(
        createAgeAsync,
        { mutationKey: mutationCreateQueryKey, }
    );

    const onCreateAsync = async (values) => {
        try {

            console.log('on create callback', values);

            const response = await createNewAgeAsync(values);

            if (response.code === 0) {
                refetch();
                closeCreateModal();
                message.success('Age was created successfully');

            } if (response && response.code !== 0) {
                message.error('Age could not be created');
                closeCreateModal();
            }

            console.log('updated resonse', response);

        } catch (error) {
            console.log('on update async', error);
        }
    }

    //#endregion 

    const onSortChange = (sort) => {
        try {

            console.log('sort', sort)

            const { field, order, column } = sort || {};

            if (column) {
                setSearchParams(p => ({ ...p, sortBy: field, sortOrder: order, pageNo: 0 }));
            } else {
                setSearchParams(p => ({ ...p, sortBy: null, sortOrder: null, pageNo: 0 }));
            }

        } catch (error) {
            console.log('error sorting', error);
        }
    }

    const onPagniationChange = (pagination) => {
        try {

            console.log('on change', pagination,);
            let currentPage = get(pagination, 'current');
            currentPage = currentPage > 0 ? currentPage - 1 : pageNo;
            setSearchParams(p => ({ ...p, pageNo: currentPage }));


        } catch (error) {
            console.log('error on table change', error);
        }
    }

    const styles = useMemo(() => ({
        itemStyle: {
            paddingRight: 16,
            paddingBottom: 18,
        },
    }), [])

    //#region delete

    const [deleteDifficultyId, setDeleteDifficultyId] = useState();

    const deleteMutationQueryKey = [queryKeys.deleteAge, deleteDifficultyId]

    const deleteDifficultyAsync = async (ageId) => {
        try {

            const link = appLinks.deleteAge.replace('{ageId}', ageId);
            const deleteResponse = await httpDeleteAsync(link);

            console.log('delete response', deleteResponse);

            return deleteResponse;

        } catch (error) {
            console.log('error deleting age', error);
        }
    }

    const {
        // data: updatePersonResponse,
        isLoading: isDeleting,
        mutateAsync: onDeleteAgeAsync,
    } = useMutation(
        deleteDifficultyAsync,
        { mutationKey: deleteMutationQueryKey, }
    );

    const onDelete = (ageId) => {
        try {

            console.log('delete age entry', ageId);
            Promise.resolve(setDeleteDifficultyId(ageId))

            Modal.confirm({
                title: `Are you sure you want to delete the age entry`,
                okText: 'Delete',
                closable: true,
                okButtonProps: {
                    loading: isDeleting,
                    disabled: isDeleting,
                },
                onOk: async () => {
                    console.log('on delete click');

                    const deleteResponse = await onDeleteAgeAsync(ageId);

                    if (deleteResponse && deleteResponse.code === 0) {
                        message.success(' Age was deleted successfully');
                    } else {
                        message.error('We are facing some issues, Age could not be deleted');
                    }

                    await refetch();

                }

            });

        } catch (error) {
            console.log('error deleting theme', error);
        }
    }

    //#endregion

    // const { 
    const hasCreateAccess = true;
    const hasEditAccess = true;
    const hasDeleteAccess = true;
    //} = useDifficultyPermissionsContext();

    const [resetKey, setResetKey] = useState(0);

    const onReset = () => {
        resetSearchParams();
        setResetKey(k => k + 1);
    }

    return (
        <React.Fragment>
            <Dashboard subrouting={false} openKeys={['settings']} activeItem='settings-ages'>
                <Row justify='space-between' style={{ paddingBottom: '18px' }} gutter={24}>
                    <Col>
                        <Row>
                            <Col style={{ paddingRight: 15 }}>
                                <OrganisationsLookup
                                    mode='single'
                                    onChange={onOrganisationChange}
                                    defaultValue={organisationId}
                                    value={organisationId}
                                    style={{ width: 200 }}
                                    placeholder="Select Organisation"
                                    showSearch
                                    labelInValue={false}
                                />
                            </Col>
                            <Col style={styles.itemStyle}>
                                {/* <Search
                                    key={resetKey}
                                    placeholder="Search"
                                    initialValue={query}
                                    onSearch={onSearch}
                                    allowClear
                                    style={{ width: 200 }}
                                /> */}
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            data-testid='create-age'
                            disabled={!hasCreateAccess}
                            block
                            onClick={showCreateModal}
                        >
                            New Age
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col push={23}>
                        {
                            isSearchActive
                                ? (
                                    <Button type="link" size='small' onClick={onReset} style={{ marginBottom: 8 }} >
                                        Reset
                                    </Button>
                                )
                                : null
                        }
                    </Col>
                </Row>
                <Spin spinning={isLoading || isFetching}>
                    <Table
                        items={difficulty}
                        showEditModal={showEditModal}
                        onPagniationChange={onPagniationChange}
                        onSortChange={onSortChange}
                        onDelete={onDelete}
                        pageNo={pageNo}
                        total={total}
                        defaultPageSize={pageSize}
                        key={resetKey}
                        sortBy={sortBy}
                        sortOrder={sortOrder}
                        hasEditAccess={hasEditAccess}
                        hasDeleteAccess={hasDeleteAccess}
                    />
                </Spin>
            </Dashboard>
            <Modal
                title="Edit"
                visible={isEditVisible}
                onOk={onEditClick}
                onCancel={closeEditModal}
                okText='Save'
                okButtonProps={{
                    loading: isUpdating
                }}
                destroyOnClose
            >
                <EditForm
                    form={editForm[0]}
                    organisationId={organisationId}
                    age={editDifficultyLevel?.age}
                    onUpdateAsync={onUpdateAsync}
                />
            </Modal>
            <Modal
                title="New"
                open={isCreateVisible}
                onOk={onCreateClick}
                onCancel={closeCreateModal}
                okText='Save'
                okButtonProps={{
                    loading: isCreating
                }}
                destroyOnClose
            >
                <CreateForm
                    form={createForm[0]}
                    organisationId={organisationId}
                    onCreateCallback={onCreateAsync}
                />
            </Modal>
        </React.Fragment>
    )

}